import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RegistrationFlowType } from "./constant";
import { updateBuyerRegistrationField } from "../../../../../redux/slice/buyerSlice";
import useTranslationHook from "../../../../hooks/useTranslationHook";
import ConfirmRegistrationTypeChange from "../modals/ConfirmRegistrationTypeChange";
import RegistrationDetails from "./RegistrationDetails";
import { fetchKycDetail } from "../../../../../redux/action/buyerAction";

const RegistrationType = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { state } = useLocation();
    const { t } = useTranslationHook();
    const lang = useSelector((state) => state.translation.lang);
    const [showForm, setShowForm] = useState(false);
    const registrationType = useSelector(
        (state) => state.buyer.buyerRegistration.registrationType
    );
    const { isSelf } = useMemo(
        () => ({
            isSelf: registrationType === RegistrationFlowType.SELF,
            // ADREC: isPrincipal removed — "Register for someone else" option gone.
            // isPrincipal: registrationType === RegistrationFlowType.PRINCIPAL,
        }),
        [registrationType]
    );
    const stepOneData = useSelector((state) =>
        isSelf
            ? state.buyer.buyerRegistration.self.stepOneData
            : state.buyer.buyerRegistration.principal.stepOneData
    );

    const isApproved = useSelector(
        (state) => state.buyer.buyerRegistration.is_approved
    );
    const sellerComment = useSelector(
        (state) => state.buyer.buyerRegistration.seller_comment
    );

    const registration_id = useSelector(
        (state) => state.buyer.buyerRegistration.registration_id
    );
    const showRegForm = useSelector(
        (state) => state.buyer.buyerRegistration.showForm
    );
    const [isDirty, setIsDirty] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [pendingForm, setPendingForm] = useState(null);

    useEffect(() => {
        setShowForm(showRegForm);
    }, [showRegForm]);

    const handleNextClick = useCallback(() => {
        if (!registrationType) return;
        setShowForm(true);
    }, [registrationType]);

    const updateRegistrationType = useCallback((value) => {
        dispatch(
            updateBuyerRegistrationField({
                field: "registrationType",
                value,
            })
        );
    }, []);

    const handleRegistrationTypeChange = useCallback(
        (value) => {
            if (isDirty) {
                setShowConfirm(true);
                setPendingForm(value);
                return;
            }

            updateRegistrationType(value);
        },
        [isDirty, updateRegistrationType]
    );

    const handleConfirmSwitch = useCallback(() => {
        if (!pendingForm) return;
        setIsDirty(false);
        setPendingForm(null);
        setShowConfirm(false);
        updateRegistrationType(pendingForm);
    }, [pendingForm, updateRegistrationType]);
    const handleCancelSwitch = useCallback(() => {
        setPendingForm(null);
        setShowConfirm(false);
    }, []);

    return (
        <div>
            <div className="step-1">
                {state?.selectedSessionID ? (
                    <section className="lot-progress">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-8 col-md-10 col-sm-12">
                                    <h5>
                                        <span>
                                            {t("STEP 1/4")} <circle></circle>{" "}
                                            {t(
                                                "Registering for Live Auction Name"
                                            )}
                                        </span>
                                        {t("Registration Type")}
                                        <em>
                                            {t(
                                                "How would you like to participate in this auction?"
                                            )}
                                        </em>
                                    </h5>
                                    <ul>
                                        <li className="step"></li>
                                        <li></li>
                                        <li></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>
                ) : (
                    <section className="bidder-progress">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-8 col-md-10 col-sm-12">
                                    <h5>
                                        <span>1/2</span>
                                        {t("Proceed to Sign")}
                                    </h5>
                                    <ul>
                                        <li className="step active"></li>
                                        <li></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>
                )}
                {state?.selectedSessionID ? (
                    <section className="lot-form">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-8 col-md-10 col-sm-12">
                                    {isApproved === 3 && (
                                        <div className="feedback-msg mb-3">
                                            <div className="icon">
                                                <img
                                                    src="/img/info-icon-ornge.svg"
                                                    alt=""
                                                />
                                            </div>
                                            <h6>
                                                {t("Registration Rejected")}
                                            </h6>
                                            <p>
                                                {t(
                                                    sellerComment ||
                                                        "Your registration could not be completed. Please review the details below."
                                                )}
                                            </p>
                                        </div>
                                    )}
                                    <div className="radio-btns">
                                        <div className="radio-block">
                                            <div className="">
                                                <input
                                                    name="registrationType"
                                                    type="radio"
                                                    className="css-radio"
                                                    disabled={
                                                        registration_id &&
                                                        registrationType ===
                                                            RegistrationFlowType.PRINCIPAL
                                                    }
                                                    id="register"
                                                    checked={
                                                        registrationType ===
                                                        RegistrationFlowType.SELF
                                                    }
                                                    onChange={() =>
                                                        handleRegistrationTypeChange(
                                                            RegistrationFlowType.SELF
                                                        )
                                                    }
                                                />
                                                <label
                                                    htmlFor="register"
                                                    className="css-labell"
                                                ></label>
                                            </div>
                                            <h6>
                                                {t("Register for myself")}
                                                <span>
                                                    {t(
                                                        "I will be the primary bidder and payer."
                                                    )}
                                                </span>
                                            </h6>
                                        </div>
                                        {/* ADREC: "Register for someone else" (Principal
                                            registration) option removed — registration is self-only.
                                            The principal code paths remain but are now unreachable. */}
                                        <></>
                                    </div>
                                    {showForm && (
                                        <div
                                            className={`${stepOneData?.isKycAvailable ? "" : "register-for-someone"} ${state?.selectedSessionID && registrationType !== RegistrationFlowType.SELF ? "priciple-container" : ""}`}
                                        >
                                            <RegistrationDetails
                                                onDirtyChange={setIsDirty}
                                            />
                                        </div>
                                    )}

                                    {stepOneData?.isKycAvailable &&
                                    state?.selectedSessionID ? (
                                        <></>
                                    ) : (
                                        !showForm && (
                                            <div className="bidder-btns mt-5">
                                                <button
                                                    onClick={() => navigate(-1)}
                                                    className="btn btn-sky back-btn"
                                                >
                                                    <img
                                                        src="/img/arrow-left.svg"
                                                        className="mr4"
                                                        alt=""
                                                        style={{
                                                            transform:
                                                                lang === "ar"
                                                                    ? "rotate(180deg)"
                                                                    : "none",
                                                        }}
                                                    />{" "}
                                                    {t("Back")}
                                                </button>
                                                <button
                                                    className="btn btn-primary forward-btn"
                                                    disabled={!registrationType}
                                                    onClick={handleNextClick}
                                                >
                                                    {t("Next")}{" "}
                                                    <img
                                                        src="/img/arrow-right.svg"
                                                        className="ml4"
                                                        alt=""
                                                        style={{
                                                            transform:
                                                                lang === "ar"
                                                                    ? "rotate(180deg)"
                                                                    : "none",
                                                        }}
                                                    />
                                                </button>
                                            </div>
                                        )
                                    )}
                                </div>
                            </div>
                        </div>
                    </section>
                ) : (
                    <section className="bidder-form">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-8 col-md-10 col-sm-12">
                                    {isApproved === 3 && (
                                        <div className="feedback-msg mb-1">
                                            <div className="icon">
                                                <img
                                                    src="/img/info-icon-ornge.svg"
                                                    alt=""
                                                />
                                            </div>
                                            <h6>
                                                {t("Registration Rejected")}
                                            </h6>
                                            <p>
                                                {t(
                                                    sellerComment ||
                                                        "Your registration could not be completed. Please review the details below."
                                                )}
                                            </p>
                                        </div>
                                    )}
                                    {/* Hiding as per requirement
                                    <div className="mb-3">
                                        <label
                                            htmlFor=""
                                            className="form-label"
                                        >
                                            {t(
                                                "Please Selects Registration Type"
                                            )}
                                        </label>
                                        <div className="radio-btns">
                                            <div className="">
                                                <input
                                                    name="registrationType"
                                                    type="radio"
                                                    className="css-radio"
                                                    disabled={
                                                        registration_id &&
                                                        registrationType ===
                                                            RegistrationFlowType.PRINCIPAL
                                                    }
                                                    id="register"
                                                    checked={
                                                        registrationType ===
                                                        RegistrationFlowType.SELF
                                                    }
                                                    onChange={() =>
                                                        handleRegistrationTypeChange(
                                                            RegistrationFlowType.SELF
                                                        )
                                                    }
                                                />
                                                <label
                                                    htmlFor="register"
                                                    className="css-labell"
                                                >
                                                    {t("Register For Myself")}
                                                </label>
                                            </div>
                                            {state?.selectedSessionID &&
                                            state?.selfRegistration ? (
                                                <></>
                                            ) : (
                                                <div className="">
                                                    <input
                                                        name="registrationType"
                                                        type="radio"
                                                        className="css-radio"
                                                        id="someone"
                                                        disabled={
                                                            registration_id &&
                                                            registrationType ===
                                                                RegistrationFlowType.SELF
                                                        }
                                                        checked={
                                                            registrationType ===
                                                            RegistrationFlowType.PRINCIPAL
                                                        }
                                                        onChange={() =>
                                                            handleRegistrationTypeChange(
                                                                RegistrationFlowType.PRINCIPAL
                                                            )
                                                        }
                                                    />
                                                    <label
                                                        htmlFor="someone"
                                                        className="css-labell"
                                                    >
                                                        {t(
                                                            "Register For Someone Else (Principal)"
                                                        )}
                                                    </label>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    */}

                                    {showForm && (
                                        <div>
                                            <RegistrationDetails
                                                onDirtyChange={setIsDirty}
                                            />
                                        </div>
                                    )}

                                    {!showForm && (
                                        <div className="bidder-btns">
                                            <button
                                                onClick={() => navigate(-1)}
                                                className="btn btn-sky back-btn"
                                            >
                                                <img
                                                    src="/img/arrow-left.svg"
                                                    className="mr4"
                                                    alt=""
                                                    style={{
                                                        transform:
                                                            lang === "ar"
                                                                ? "rotate(180deg)"
                                                                : "none",
                                                    }}
                                                />{" "}
                                                {t("Back")}
                                            </button>
                                            <button
                                                className="btn btn-primary forward-btn"
                                                disabled={!registrationType}
                                                onClick={handleNextClick}
                                            >
                                                {t("Next")}{" "}
                                                <img
                                                    src="/img/arrow-right.svg"
                                                    className="ml4"
                                                    alt=""
                                                    style={{
                                                        transform:
                                                            lang === "ar"
                                                                ? "rotate(180deg)"
                                                                : "none",
                                                    }}
                                                />
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </section>
                )}
            </div>

            {showConfirm && (
                <ConfirmRegistrationTypeChange
                    show={showConfirm}
                    onClose={handleCancelSwitch}
                    confirmSwitch={handleConfirmSwitch}
                    cancelSwitch={handleCancelSwitch}
                />
            )}

        </div>
    );
};

export default RegistrationType;
